/* Tab switcher for the Iveraco mega menu panel.
   Follows the WAI-ARIA tabs pattern: click or Left/Right/Home/End to move,
   roving tabindex, aria-selected kept in sync. Re-runs on section reload so
   the Theme Editor stays live. */
(function () {
  function init(root) {
    if (root.dataset.ivReady) return;
    root.dataset.ivReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i); });
      tab.addEventListener('keydown', function (e) {
        var next = i;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        else return;
        e.preventDefault();
        activate(next);
        tabs[next].focus();
      });
    });
  }

  /* The panels are hidden until hover, and lazy images inside display:none
     never start loading, so the circles would flash empty on the first
     hover. The first time a pointer enters the header, flip the panel
     thumbnails to eager; they are 100px images, so they arrive before the
     pointer reaches a menu item. Touch devices never fire this and the
     drawer loads its own copies when a panel opens. */
  function warmThumbnails() {
    document.querySelectorAll('[data-iv-mega] img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }

  function boot() {
    document.querySelectorAll('[data-iv-mega]').forEach(init);
    var header = document.querySelector('.m-header');
    if (header && !header.dataset.ivWarm) {
      header.dataset.ivWarm = '1';
      header.addEventListener('mouseenter', warmThumbnails, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
